import { ReactElement, Suspense } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import { BottomNavigationSkeleton } from './BottomNavigationSkeleton';
import { NavigationWrapper } from './style';

const { BottomNavigationContent } = lazy(
  () => import(/* webpackChunkName: "bottom-navigation-content" */ './Content')
);

export const BottomNavigation = (): ReactElement | null => {
  return SpringConfigs.BOTTOM_NAVIGATION && isMobile() ? (
    <Suspense
      fallback={
        <NavigationWrapper>
          <BottomNavigationSkeleton />
        </NavigationWrapper>
      }
    >
      <BottomNavigationContent />
    </Suspense>
  ) : null;
};
